import React from 'react';

export const Card = ({ title, tag, children, className = '', testId }) => (
  <section className={`pie-card fl-card ${className}`} data-testid={testId}>
    {(title || tag) && <div className="fl-card-head">{title && <h2 className="pie-card-title">{title}</h2>}{tag}</div>}
    {children}
  </section>
);

export const Chip = ({ children, accent, active, onClick, testId }) => {
  const cls = `pie-chip ${accent ? 'pie-chip-accent' : ''} ${active ? 'fl-chip-active' : ''}`;
  return onClick ? <button type="button" className={cls} onClick={onClick} aria-pressed={!!active} data-testid={testId}>{children}</button> : <span className={cls} data-testid={testId}>{children}</span>;
};

export const Btn = ({ children, primary, active, onClick, testId }) => (
  <button type="button" className={`pie-btn ${primary ? 'pie-btn-primary' : 'pie-btn-ghost'} ${active ? 'fl-btn-active' : ''}`} onClick={onClick} aria-pressed={active ? 'true' : undefined} data-testid={testId}>{children}</button>
);

export const Demo = ({ label = 'Demo data' }) => <span className="fl-demo-tag" data-testid="fl-demo-tag">{label}</span>;

export const Score = ({ label, value, delta, before, hint }) => (
  <div className="fl-score" data-testid={`fl-score-${label.toLowerCase().replace(/ /g, '-')}`}>
    <span className="fl-score-label">{label}</span>
    <span className="fl-score-value">{value}{typeof value === 'number' && value <= 100 && typeof delta !== 'number' && !hint ? <small> / 100</small> : null}</span>
    {typeof delta === 'number' && <span className="fl-delta">{before} → {value} <strong>{delta > 0 ? '+' : ''}{delta}</strong></span>}
    {hint && <span className="fl-small">{hint}</span>}
  </div>
);

const TONE = { COMPLETE: 'ok', DEMONSTRATED: 'ok', IMPROVING: 'ok', BUILDING: 'warn', 'NEEDS SUPPORT': 'bad', 'NOT YET ESTABLISHED': 'bad', BASELINE: 'muted' };
export const Journey = ({ stages }) => (
  <ol className="fl-journey">
    {stages.map(([name, status]) => <li key={name} data-testid={`fl-stage-${name.toLowerCase()}`}><span>{name}</span><span className={`fl-status fl-status-${TONE[status] || 'muted'}`}>{status}</span></li>)}
  </ol>
);

export const Scale = ({ label, value, onChange, hint, testId }) => (
  <div className="fl-field" data-testid={testId}>
    <p className="fl-label">{label}</p>
    <div className="fl-row">{[1, 2, 3, 4, 5].map((n) => <button key={n} type="button" className={`fl-scale ${value === n ? 'fl-scale-active' : ''}`} onClick={() => onChange(n)} aria-pressed={value === n} data-testid={`${testId}-${n}`}>{n}</button>)}{hint && <Chip accent>{hint}</Chip>}</div>
  </div>
);

export const Choice = ({ label, options, value, onChange, testId }) => (
  <div className="fl-field" data-testid={testId}>
    <p className="fl-label">{label}</p>
    <div className="fl-row fl-chips">{options.map((o) => <Chip key={o} active={value === o} onClick={() => onChange(o)} testId={`${testId}-${o.toLowerCase().replace(/[^a-z]+/g, '-')}`}>{o}</Chip>)}</div>
  </div>
);
